/**
 * @generated SignedSource<<94da37b7e48ac8becc34cef9fd379524>>
 * @relayHash b90747b62ba7f6e878a7ff5cc8ef3c80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0963d5c6aa73373331ad77eb2c615c63aed9997921c29acc3cef25b76ac86897

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "0963d5c6aa73373331ad77eb2c615c63aed9997921c29acc3cef25b76ac86897",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
